import { getOrderDetails } from "../../../api/get/getOrderDetails";
import { getOrderStatus } from "../../../api/post/orderStatusApi";
import { processManualOrder } from "../../../api/post/paymentCheckoutApi";
import {
  setOrderInfo,
  setOrderStatus,
  setPastOrderDetails,
} from "./orderSlice";

export const checkoutProcessAsync = (orderData) => async (dispatch) => {
  try {
    const response = await processManualOrder(orderData);
    dispatch(setOrderInfo(response)); // Update the cart state
    return response; // Return the response
  } catch (error) {
    console.error("Add to Cart request failed:", error);
    throw error; // Re-throw the error for handling in the component
  }
};

export const pollOrderStatusAsync = (orderNo) => async (dispatch, getState) => {
  let intervalId;
  const promise = new Promise((resolve) => {
    intervalId = setInterval(async () => {
      try {
        // Get current location from state or pass it as parameter
        const isCheckoutScreen = window.location.pathname === "/checkout";
        
        // Stop polling if we're not on checkout screen
        if (!isCheckoutScreen) {
          clearInterval(intervalId);
          resolve();
          return;
        }

        const statusData = await getOrderStatus(orderNo);
        const currentStatus = getState().orders.orderStatus;

        // Only dispatch if the status has changed
        if (currentStatus !== statusData.order_status) {
        dispatch(setOrderStatus(statusData.order_status));
        }

        if (["Submitted", "Failed"].includes(statusData.order_status)) {
          clearInterval(intervalId);
          resolve();
        }
      } catch (error) {
        console.error("Polling error:", error);
        clearInterval(intervalId);
        resolve();
      }
    }, 7000);
  });

  return { intervalId, promise };
};

export const getPastOrderDetailsAsync = (orderId) => async (dispatch) => {
  try {
    const response = await getOrderDetails(orderId);
    dispatch(setPastOrderDetails(response));
  } catch (error) {
    console.error("Get past order details request failed:", error);
  }
};
